import Home from "./components/home/Home";
import AccountWrapper from "./components/account/AccountWrapper";
import ServicesWrapper from "./components/services/ServicesWrapper";
import ServicesDetailsWrapper from "./components/services/ServicesDetailsWrapper";
import CurrenciesWrapper from "./components/currencies/CurrenciesWrapper";
import ConnectedServicesWrapper from "./components/connectedServices/ConnectedServicesWrapper";
import ProjectWrapper from "./components/projects/ProjectWrapper";
import PaymentWrapper from "./components/payments/PaymentWrapper";
import PayoutWrapper from "./components/payouts/PayoutWrapper";
import ProjectDetailsWrapper from "./components/projects/ProjectDetailsWrapper";
import PaymentDetailsWrapper from "./components/payments/PaymentDetailsWrapper";
import PayoutDetailsWrapper from "./components/payouts/PayoutDetailsWrapper";
import FeeWrapper from "./components/fee/FeeWrapper";
import FeeDetailsWrapper from "./components/fee/FeeDetailsWrapper";
import ClientsWrapper from "./components/clients/ClientsWrapper";
import ClientsFeeWrapper from "./components/clients/ClientsFeeWrapper";
import ClientDetailsWrapper from "./components/clients/ClientDetailsWrapper";
import DefaultFeeWrapper from "./components/defaultFee/DefaultFeeWrapper";
import DefaultFeeDetailsWrapper from "./components/defaultFee/DefaultFeeDetailsWrapper";
import RatesWrapper from "./components/rates/RatesWrapper";
import RatesDetailsWrapper from "./components/rates/RatesDetailsWrapper";
import BatchesWrapper from "./components/batches/BatchesWrapper";
import BatchesDetailsWrapper from "./components/batches/BatchesDetailsWrapper";
import LogsWrapper from "./components/logs/LogsWrapper";
import BaseRatesWrapper from "./components/baseRates/BaseRatesWrapper";
import BaseRatesDetailsWrapper from "./components/baseRates/BaseRatesDetailsWrapper";
import ClientsRateWrapper from "./components/clients/ClientsRateWrapper";
import ClientsRangeFeeWrapper from "./components/clients/ClientsRangeFeeWrapper";
import BlockchainUrlWrapper from "./components/blockchainUrl/BlockchainUrlWrapper";
import BlockchainUrlDetailsWrapper from "./components/blockchainUrl/BlockchainUrlDetailsWrapper";
import CashFlowWrapper from "./components/cashFlow/CashFlowWrapper";
import TransferWrapper from "./components/transfer/TransferWrapper";
import SupportUserWrapper from "./components/supportUser/SupportUserWrapper";
import SupportUserDetailsWrapper from "./components/supportUser/SupportUserDetailsWrapper";
import SystemCommandWrapper from "./components/systemCommands/SystemCommandWrapper";
import ServiceBalancesWrapper from "./components/serviceBalances/ServiceBalancesWrapper";
import Exchange from "./components/exchange/Exchange";
import ExchangeDetails from "./components/exchange/ExchangeDetails";
import ExchangePairsDetailsContainer from "./components/exchange/master/pairs/ExchangePairsDetailsContainer";
import ExchangeUserPairsDetailsContainer from "./components/exchange/master/userPairs/ExchangeUserPairsDetailsContainer";
import ExchangeProfitDetailsContainer from "./components/exchange/master/profit/exchangeProfitDetails/ExchangeProfitDetailsContainer";
import MasterBalancesWrapper from "./components/masterBalances/MasterBalancesWrapper";
import MasterBalancesHistoryWrapper from "./components/masterBalances/MasterBalancesHistoryWrapper";
import MasterRefillingsWrapper from "./components/masterRefillings/MasterRefillingsWrapper";
import MasterRefillingsDetailsWrapper from "./components/masterRefillings/MasterRefillingsDetailsWrapper";
import BinsWrapper from "./components/binData/BinsWrapper";
import ClientServicesDetailsWrapper from "./components/clients/superAdmin/services/details/ClientServicesDetailsWrapper";
import SwapWrapper from "./components/swap/SwapWrapper";
import TransactionsWrapper from "./components/transactions/TransactionsWrapper";
import TransactionDetailsWrapper from "./components/transactions/TransactioDetailsWrapper";
import WalletsWrapper from "./components/wallets/WalletsWrapper";
import WalletDetailsWrapper from "./components/wallets/WalletDetailsWrapper";
import WalletMainWhitelistWrapper from "./components/walletMainWhitelist/WalletMainWhitelistWrapper";
import WalletWhitelistWrapper from "./components/walletWhitelist/WalletWhitelistWrapper";
import TelegramChatsWrapper from "./components/telegramBot/TelegramChatsWrapper";

const routes = [
  {
    title: "Main",
    path: "/",
    exact: true,
    component: Home
  },
  {
    title: "AccountWrapper",
    path: "/account",
    component: AccountWrapper
  },
  {
    title: "Cash Flow",
    path: "/cash-flow",
    component: CashFlowWrapper
  },
  {
    title: "Projects",
    path: "/projects",
    exact: true,
    component: ProjectWrapper
  },
  {
    title: "Payments",
    path: "/payments",
    exact: true,
    component: PaymentWrapper
  },
  {
    title: "Payouts",
    path: "/payouts",
    exact: true,
    component: PayoutWrapper
  },
  {
    title: 'Transfers',
    path: "/transfers",
    exact: true,
    component: TransferWrapper
  },
  {
    title: 'Exchange history',
    path: "/exchange",
    exact: true,
    component: Exchange
  },
  {
    title: 'Exchange history details',
    path: "/exchange/:id",
    exact: true,
    component: ExchangeDetails
  },
  {
    title: "Exchange pair details",
    path: "/exchange/pairs/:id",
    component: ExchangePairsDetailsContainer
  },
  {
    title: "Exchange user pair details",
    path: "/exchange/user-pairs/:id",
    component: ExchangeUserPairsDetailsContainer
  },
  {
    title: "Projects details",
    path: "/projects/:id",
    component: ProjectDetailsWrapper
  },
  {
    title: "Services",
    path: "/services",
    component: ServicesWrapper,
    exact: true
  },
  {
    title: "Services details",
    path: "/services/:id",
    component: ServicesDetailsWrapper
  },
  {
    title: "Connected services",
    path: "/connected-services",
    component: ConnectedServicesWrapper,
    exact: true
  },
  {
    title: "Payment details",
    path: "/payments/:id",
    component: PaymentDetailsWrapper
  },
  {
    title: "Payout details",
    path: "/payouts/:id",
    component: PayoutDetailsWrapper
  },
  {
    title: "Currencies",
    path: "/currencies",
    component: CurrenciesWrapper,
    exact: true
  },
  {
    title: "Fees",
    path: "/fees",
    component: FeeWrapper,
    exact: true
  },
  {
    title: "Default Fees",
    path: "/default-fees",
    component: DefaultFeeWrapper,
    exact: true
  },
  {
    title: "Default Fees details",
    path: "/default-fees/:id",
    component: DefaultFeeDetailsWrapper,
    exact: true
  },
  {
    title: "Fee details",
    path: "/fees/:id",
    component: FeeDetailsWrapper
  },
  {
    title: "Clients",
    path: "/clients",
    component: ClientsWrapper,
    exact: true
  },
  {
    title: "Client details",
    path: "/clients/fee/:id",
    component: ClientsFeeWrapper
  },
  {
    title: "Client details",
    path: "/clients/range-fee/:id",
    component: ClientsRangeFeeWrapper
  },
  {
    title: "Client details",
    path: "/clients/rate/:id",
    component: ClientsRateWrapper
  },
  {
    title: "Client details",
    path: "/clients/:id",
    component: ClientDetailsWrapper
  },
  {
    title: "Rates",
    path: "/rates",
    component: RatesWrapper,
    exact: true
  },
  {
    title: "Rates details",
    path: "/rates/:id",
    component: RatesDetailsWrapper
  },
  {
    title: "Base rates",
    path: "/base-rates",
    component: BaseRatesWrapper,
    exact: true
  },
  {
    title: "Rates details",
    path: "/base-rates/:id",
    component: BaseRatesDetailsWrapper
  },
  {
    title: "Batches",
    path: "/Batches",
    component: BatchesWrapper,
    exact: true
  },
  {
    title: "Batches details",
    path: "/batches/:id",
    component: BatchesDetailsWrapper
  },
  {
    title: "Logs",
    path: "/Logs",
    component: LogsWrapper,
    exact: true
  },
  {
    title: "Blockchain Urls",
    path: "/blockchain-urls",
    component: BlockchainUrlWrapper,
    exact: true
  },
  {
    title: "Blockchain Urls details",
    path: "/blockchain-urls/:id",
    component: BlockchainUrlDetailsWrapper
  },
  {
    title: "Support user",
    path: "/support-user",
    component: SupportUserWrapper,
    exact: true
  },
  {
    title: "Support user details",
    path: "/support-user/:id",
    component: SupportUserDetailsWrapper
  },
  {
    title: "System command",
    path: "/system-command",
    component: SystemCommandWrapper,
    exact: true
  },
  {
    title: "Service balances",
    path: "/service-balances",
    component: ServiceBalancesWrapper,
    exact: true
  },
  {
    title: "Ex profit details",
    path: "/exchange-profit-details/:id",
    component: ExchangeProfitDetailsContainer,
    exact: true
  },
  {
    title: "Master balances",
    path: "/master-balances",
    component: MasterBalancesWrapper,
    exact: true
  },
  {
    title: "Master balances history",
    path: "/master-balances/:id/history",
    component: MasterBalancesHistoryWrapper,
    exact: true
  },
  {
    title: "Master refillings",
    path: "/master-refillings",
    component: MasterRefillingsWrapper,
    exact: true
  },
  {
    title: "Master refillings details",
    path: "/master-refillings/:id",
    component: MasterRefillingsDetailsWrapper,
    exact: true
  },
  {
    title: "Admin bin data",
    path: "/bin-data",
    component: BinsWrapper,
    exact: true
  },
  {
    title: "Client connections",
    path: "/connections/:userId/:serviceId",
    component: ClientServicesDetailsWrapper,
    exact: true
  },
  {
    title: "Swap",
    path: "/swap",
    component: SwapWrapper,
    exact: true
  },
  {
    title: "Transactions",
    path: "/transactions",
    component: TransactionsWrapper,
    exact: true
  },
  {
    title: "Transaction details",
    path: "/transaction/:type/:id",
    component: TransactionDetailsWrapper,
    exact: true
  },
  {
    title: "Wallets",
    path: "/wallets",
    component: WalletsWrapper
  },
  {
    title: "Wallet details",
    path: "/wallet/:id",
    component: WalletDetailsWrapper
  },
  {
    title: "Wallet main whitelist",
    path: "/wallet-main-whitelist",
    component: WalletMainWhitelistWrapper
  },
  {
    title: "Wallet whitelist",
    path: "/wallet-whitelist",
    component: WalletWhitelistWrapper
  },
  {
    title: "Telegram Chats",
    path: "/telegram-chats",
    component: TelegramChatsWrapper
  },
];

export default routes;
